export default __webpack_public_path__ + "static/media/Group14.3bc583bb.png";